(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mypc-gold-certification"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const button=event.target.closest('[data-mypc-gold-close]');if(!button)return;event.preventDefault();event.stopPropagation();const popup=button.closest('[data-mypc-gold]');popup.classList.add('is-closing');setTimeout(()=>{popup.hidden=true},260);});
  } catch(e) { console.error(e); }
})();

})();
